<div id="payment" class="registration container" *ngIf="programInfo">
    <form #paymentForm="ngForm" name="paymentForm" (ngSubmit)="forward(paymentForm)"
        novalidate autocomplete="off" appScrollToInvalid
        [ngClass]="{'form-complete': isFormCompleted}">
        <h1>{{"copy.label.PAYMENT.heading"|copy|async}}</h1>
        <div [innerHTML]='"copy.html.CreditCard" | copy | async'></div>

        <!-- <section class="card" name="conferenceFee" *ngIf="Total === 0">
            <app-collect-payment cardType="Conference"
            header="copy.label.PAYMENT.FEESRT10.guarantee"
            additionaltext="copy.html.cancelNote"
            ></app-collect-payment>
        </section> -->

        <section class="card" name="conferenceFee" *ngIf="charges.Conference > 0 && !showCancellation">
            <app-collect-payment cardType="Conference"
            header="copy.label.PAYMENT.FEESRT10.conference"
            [cost]="charges.Conference|currency"></app-collect-payment>
        </section>

        <section class="card" name="conferenceFee" *ngIf="charges.Conference > 0 && showCancellation">
            <app-collect-payment cardType="Conference"
            header="copy.label.PAYMENT.FEESRT10.conference"
            additionaltext="copy.html.conferenceNote"
            [cost]="charges.Conference|currency"></app-collect-payment>
        </section>

        <section class="card" name="hotelFee" *ngIf="charges.Hotel > 0">
            <app-collect-payment cardType="Hotel"
            header="copy.label.PAYMENT.FEESRT10.hotel"
            [cost]="charges.Hotel|currency"
            additionaltext="copy.html.OtherPayment"></app-collect-payment>
        </section>

        <section class="card" name="activityFee" *ngIf="charges.Activity > 0">
            <app-collect-payment cardType="Activity"
            header="copy.label.PAYMENT.FEESRT10.activity"
            [cost]="charges.Activity|currency"></app-collect-payment>
        </section>

        <section class="card" name="guestFee" *ngIf="charges.Guest > 0">
            <app-collect-payment cardType="Guest"
            header="copy.label.PAYMENT.FEESRT10.guest"
            [cost]="charges.Guest|currency"></app-collect-payment>
        </section>

        <section class="card" name="hotelFee"
            *ngIf="programInfo.hotelGuarantee && enrollment.HotelNeeded && (!charges.Hotel || charges.Hotel === 0)">
            <app-collect-payment cardType="Hotel"
            header="copy.label.PAYMENT.FEESRT10.hotelguarantee" 
            additionaltext="copy.html.HotelGuaranteeText" [ccOnly]="true"></app-collect-payment>
        </section>

        <section class="card" name="guarantee" *ngIf="needGuarantee()">
            <app-collect-payment cardType="Guarantee"
            header="copy.label.PAYMENT.FEESRT10.guarantee"
            additionaltext="copy.html.guaranteeText" [ccOnly]="true"></app-collect-payment>
        </section>

        <div class="button_group d-flex">
          <button id="back-button" type="button" class="back btn btn-outline-primary" (click)="back()" *ngIf="!isSubmitting">
            {{ 'copy.label.GLOBAL.goback' | copy | async }}
          </button>
          <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting">
            {{ 'copy.label.GLOBAL.continue' | copy | async }}
          </button>
          <button class="inputSubmit btn btn-primary ms-auto" *ngIf="isSubmitting">
            <i class="fas fa-spinner fa-spin"></i>
          </button>
        </div>
    </form>
</div>
